import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import emailjs from 'emailjs-com';
import SimpleParticlesBackground from '../ParticlesBackground/SimpleParticlesBackground';
import './Contact.css'

const contactInfo = [
    {
        id: 1,
        title: "Call Me On",
        data: '+88 01610 726 728',
        icon: faPhone
    }, {
        id: 2,
        title: "Address",
        data: 'Dakshinkhan, Dhaka-1230',
        icon: faMapMarkerAlt
    }, {
        id: 3,
        title: "Email",
        data: 'imsamrat24@gmail.com',
        icon: faEnvelope
    }
]

const Contact = () => {
    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('service_mkjade1', 'template_ucm3u9d', e.target, 'user_6LAnvpY9ii03KxcafPT6k')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset();
      }
    return (
        <>
            <div className="particles-bg">
                {/* <SimpleParticlesBackground /> */}
            </div>
            <section id="contact" className="contact section">
                <div className="container">
                    <div className="row">
                        <div className="section-title padd-15">
                            <h2>Contact Me</h2>
                        </div>
                    </div>

                    <div className="row">

                        {
                            contactInfo.map(info => <div key={info.id} className="contact-info-item padd-15">
                                <div className="icon"><FontAwesomeIcon icon={info.icon} /></div>
                                <h4>{info.title}</h4>
                                <p>{info.data}</p>
                            </div>)
                        }

                    </div>

                    <div className="row">
                        <form className="contact-form padd-15" action="" onSubmit={sendEmail}>
                            <div className="row">
                                <div className="form-item col-6 padd-15">
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Name*" name="name" required />
                                    </div>
                                </div>
                                <div className="form-item col-6 padd-15">
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Email*" name="email" required />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-item col-12 padd-15">
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Subject*" name="subject" required />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-item col-12 padd-15">
                                    <div className="form-group">
                                        <textarea type="text" className="form-control"
                                            placeholder="Your Message..." name="message" required></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 padd-15">
                                    <button type="submit" className="btn">Send Message</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </section>
        </>
    );
};

export default Contact;